import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { Jwt } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

export type CourierJwt = Omit<Jwt, "last_login">;

const useGetCourierJWT = (courierId?: number) => {
  const branchId = useBranchId();

  return useQuery<CourierJwt>({
    queryKey: ["courierJWT", branchId, courierId],
    queryFn: () =>
      post2(`/internal/secure/pos/v1/token/qr/${branchId}/${courierId}`),
    enabled: courierId !== undefined && branchId !== -1,
    // A JWT is short-lived; always fetch a fresh one when the modal opens
    gcTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useGetCourierJWT;
